const texts = {
  headerLogo: "Rolling",
  headerButton: "롤링 페이퍼 만들기",
  writed: "명이 작성했어요!",
  share: "URL 공유",
  add: "추가",
  kakaoshare: "카카오톡 공유",
  kakaobuttonTitle: "웹으로 보기",
  description: "님의 롤링 페이퍼를 확인해보세요",
  profileImageAlt: "프로필 사진",
  headerIcon: "headerIcon",
};

export default texts;
